import { Component, Input } from '@angular/core';

@Component({
  selector: 'ums-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {
  @Input() isLoading = false;
}
